// import React from 'react'
// import { Select, Spin } from 'antd'
// import debounce from 'lodash/debounce'
// import _ from 'lodash'
// import { fetchPropertyFxn } from '../action'
//
// const { Option } = Select
//
// class PropertyTypeheadComponent extends React.Component {
//   state = {
//     arrList: [],
//     value: [],
//     fetching: false,
//     name: '',
//     propertyId: ''
//   }
//
//   constructor(props) {
//     super(props)
//   }
//
//   _getUserId = () => {
//     let { propertyId } = this.props
//     if (propertyId) {
//       this.setState({
//         propertyId
//       }, () => {
//         this.fetchProperty()
//       })
//     }
//   }
//
//   componentDidMount() {
//     this._getUserId()
//   }
//
//   fetchProperty = async (name) => {
//     let { propertyId } = this.state
//     this.setState({ arrList: [], fetching: true })
//     let obj = {
//       results: 30,
//       count: 30,
//       name,
//       select: ['name'],
//       regExFilters: ['name']
//     }
//     if (propertyId && !name) {
//       obj._id = propertyId
//     }
//
//     let { data } = await fetchPropertyFxn(obj)
//     let dataNew = []
//     if (data && data.length) {
//       _.each(data, (user) => {
//         dataNew.push({
//           text: `${user.name}`,
//           value: user._id
//         })
//       })
//     }
//     let newObj = {
//       arrList: dataNew
//     }
//     if (propertyId && !name && dataNew && dataNew.length) {
//       let currentAgent = dataNew[0]
//       newObj.name = {
//         key: currentAgent.value,
//         label: currentAgent.text
//       }
//     }
//     this.setState(newObj)
//   }
//
//   handleChange = value => {
//     let { onSelect } = this.props
//     this.setState({
//       name: value,
//       propertyId: value && value.key ? value.key : '',
//       data: [],
//       fetching: false
//     })
//     onSelect((value && value.key) || '')
//   }
//
//   render() {
//     const { fetching, arrList, name, required = false } = this.state
//     let { customStyle = 'antSelect' } = this.props
//     return (
//       <Select
//         labelInValue
//         value={name || undefined}
//         className={customStyle}
//         placeholder='Select Property'
//         allowClear={true}
//         notFoundContent={fetching ? <Spin size='small' /> : null}
//         filterOption={false}
//         showSearch={true}
//         onSearch={debounce(this.fetchProperty, 500)}
//         onChange={this.handleChange}>
//         {arrList.map(d => (
//           <Option key={d.value} value={d.value}>{d.text}</Option>
//         ))}
//       </Select>
//     )
//   }
// }
//
// export default PropertyTypeheadComponent
import React from 'react'
import { AutoComplete, Spin } from 'antd'
import debounce from 'lodash/debounce'
import { fetchPropertyFxn } from '../action'

class PropertyTypeheadComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      options: [],
      fetching: false,
      inputValue: '',
      selectedId: '',
      optionMap: {}
    }

    this.debouncedFetchProperty = debounce(this.fetchProperty.bind(this), 500)
  }

  componentDidMount() {
    const { propertyId, propertyName } = this.props

    if (propertyId || propertyName) {
      this.setState({ selectedId: propertyId, inputValue: propertyName }, () => {
        this.fetchProperty()
      })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.propertyId !== this.props.propertyId || prevProps.propertyName !== this.props.propertyName) {
      this.setState({
        selectedId: this.props.propertyId,
        inputValue: this.props.propertyName
      })
    }
  }

  async fetchProperty(searchText = '') {
    this.setState({ fetching: true })

    const obj = {
      results: 30,
      count: 30,
      name: searchText,
      select: ['name'],
      regExFilters: ['name']
    }

    try {
      const { data } = await fetchPropertyFxn(obj)

      const optionMap = {}
      const options = (data || []).map(item => {
        optionMap[item.name] = item._id
        return { value: item.name }
      })

      this.setState({
        options,
        fetching: false,
        optionMap
      })
    } catch (err) {
      console.error('Error fetching properties:', err)
      this.setState({ fetching: false })
    }
  }

  handleSelect = (value) => {
    const { optionMap } = this.state
    const selectedId = optionMap[value] || ''

    this.setState({
      inputValue: value,
      selectedId
    })

    this.props.onSelect(selectedId, value)
  }

  handleChange = (value) => {
    this.setState({ inputValue: value })

    const matchedId = this.state.optionMap[value] || ''
    this.props.onSelect(matchedId, value)
  }

  render() {
    const { fetching, options, inputValue } = this.state
    return (
      <AutoComplete
        value={inputValue}
        onSearch={this.debouncedFetchProperty}
        onSelect={this.handleSelect}
        onChange={this.handleChange}
        className={'autoCompleted'}
        placeholder='Select or type property name'
        allowClear
        notFoundContent={fetching ? <Spin size="small" /> : null}
      >
        {options && options.length ? options.map((item) => (
          <AutoComplete.Option key={item.value} value={item.value}>
            {item.value}
          </AutoComplete.Option>
        )) : null}
      </AutoComplete>
    )
  }
}

export default PropertyTypeheadComponent
